import { useContext } from 'react';

import { AppNavigationContext } from '../context/AppNavigationContext';

export const useAppNavigation = () => useContext(AppNavigationContext);
